export default __webpack_public_path__ + "static/media/img1.33f300cc.jpg";